import React, { PureComponent, Fragment } from 'react';
import _ from 'lodash';
import { Trans } from 'react-i18next';
import styled from 'styled-components';

import { Row, Column } from 'common/components/styleguide/grid';
import { Headline1 } from 'common/components/styleguide/Headline';
import Alert from 'common/components/styleguide/Alert';
import Emoji from 'common/components/styleguide/Emoji';
import RouteLink from 'common/components/_base/RouteLink';

import {
  PRODUCT_DICOUNT_HOOK_TYPE,
  PRODUCT_SOFT_HOOK_TYPE,
} from 'common/constants/ProductConstants';

import { withCssUnit } from 'common/components/styleguide/utils/index';

import Rating from 'common/components/styleguide/Rating';
import Availability from 'common/components/_partials/availability/_default/index';

import Variants from 'common/components/product/detail/_default/Variants';

import loadable from '@loadable/component';
const ProductForm = loadable(() => import('common/blocks/product/detail/form'));
const AddToWishlist = loadable(() =>
  import('common/blocks/functional/addToWishlistButton')
);
const AddToCompare = loadable(() =>
  import('common/blocks/functional/addToCompareButton')
);

const S = {};

S.Title = styled.h1`
  font-size: 2em;
  @media (max-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    margin: 20px 0;
    font-size: 1.8em;
  }
`;

S.Brand = styled.strong`
  color: ${({ theme }) => _.get(theme, 'colors.lgray')};
`;

S.DescriptionShort = styled.div`
  line-height: 1.5em;
  margin: 0;
`;

S.ActionText = styled.div`
  color: ${({ theme }) => _.get(theme, 'colors.gray')};
  font-size: 0.8em;
  line-height: 1.7em;
`;

S.AvailabilityWrapper = styled.span`
  margin-right: 10px;
`;

S.Wrapper = styled.section`
  margin-top: 20px;
  @media (min-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    margin-top: 0;
  }
`;

const ActionText = ({ label, content }) => {
  if (!content) {
    return null;
  }
  return (
    <S.ActionText>
      <b>{label}:</b> {content}
    </S.ActionText>
  );
};

//@TODO: remove (treba aby api posielalo normalizovane)
const formatWarrantyDuration = (warrantyDurationInDays) => {
  switch (true) {
    // years
  case warrantyDurationInDays % 365 === 0:
    const years = warrantyDurationInDays / 365;
    return 'počet rokov ' + years;

  // months
  case warrantyDurationInDays % 31 === 0:
      const months = warrantyDurationInDays / 31;
      return 'počet mesiacov ' + months;
  // weeks
  case warrantyDurationInDays % 7 === 0:
      const weeks = warrantyDurationInDays / 7;
      return 'počet tyzdnov ' + weeks;

  // days
  default:
      return 'počet dni ' + warrantyDurationInDays;
  }
}

class ProductSummaryVariant3 extends PureComponent {
  render() {
    const {
      id,
      brand,
      name,
      subtitle,
      ean,
      partNo,
      sku,
      shortProductDescription,
      availability,
      storeStatusAvailable,
      storeStatusUnavailable,
      variants,
      productHooks = [],
      isLocked,
      warrantyDuration,
      warrantyDurationCompany,
      condition,
      t,
    } = this.props;
    const productHooksFiltred = _.filter(
      productHooks,
      (hook) =>
        hook.type === PRODUCT_DICOUNT_HOOK_TYPE ||
        hook.type === PRODUCT_SOFT_HOOK_TYPE
    );
    return (
      <Fragment>
        <Headline1>{name}</Headline1>
        {!_.isEmpty(subtitle) ? <Headline3>{subtitle}</Headline3> : ''}

        {!_.isEmpty(brand) ? <S.Brand>{brand.name}</S.Brand> : ''}

        {!isLocked ? (
          <Fragment>
            <Row>
              <Column paddingUseBottom={true} size={{ xs: 12, md: 6 }}>
                <S.DescriptionShort
                  dangerouslySetInnerHTML={{
                    __html: _.get(shortProductDescription, 'description', ''),
                  }}
                />
              </Column>
              <Column paddingUseBottom={true} size={{ xs: 12, md: 6 }}>
                <ActionText label={t('ean')} content={ean} />
                <ActionText label={t('partNo')} content={partNo} />
                <ActionText label={t('sku')} content={sku} />
                <ActionText label={t('id')} content={id} />
                <ActionText label={t('warranty')} content={formatWarrantyDuration(warrantyDuration)} />
                <ActionText
                  label={t('company warranty')}
                  content={formatWarrantyDuration(warrantyDurationCompany)}
                />
                <ActionText label={t('condition')} content={condition} />
                <Rating />
              </Column>
            </Row>

            <S.AvailabilityWrapper>
              <Availability
                availability={availability}
                text={
                  availability ? storeStatusAvailable : storeStatusUnavailable
                }
              />
            </S.AvailabilityWrapper>

            {!_.isEmpty(variants) ? (
              <Variants data={this.props} productHooks={productHooksFiltred} />
            ) : (
              <ProductForm
                product={this.props}
                productHooksFiltered={productHooksFiltred}
              />
            )}
            <Row>
              <Column size={{ xs: 12 }}>
                <AddToCompare
                  t={t}
                  productId={id}
                  linkType={'secondary'}
                />
                <br /><br />
                <AddToWishlist
                  t={t}
                  productId={id}
                  linkType={'secondary'}
                />
              </Column>
            </Row>
          </Fragment>
        ) : (
          <Alert type={'text'}>
            <Trans i18nKey="productB2BLocked">
              <strong>
                <Emoji label={'locker icon'}>🔒</Emoji> Information notice
              </strong>
              <p>
                Further information as a price, description and ability to order
                product is restricted to logged in users.
              </p>
            </Trans>
            <RouteLink route="login">
              {t('login')} / {t('register')}
            </RouteLink>
          </Alert>
        )}
      </Fragment>
    );
  }
}

export default ProductSummaryVariant3;
